import { fromTheme as kyruusFromTheme } from '@kyruus/ui-theme';
import { Theme } from '@biome-design-system/styles';

import { buildButton } from './button';
import { buildIconButton } from './iconButton';
import { buildLink } from './link';

/**
 * Builds the components configuration for the MUI theme based on Kyruus theme values.
 * @param {object} kyruusTheme - The Kyruus theme object
 * @param {object} biomeTheme - The Biome theme object (which is a MUI theme)
 * @returns {object} The components configuration for MUI theme
 */
export const buildComponents = (
  kyruusTheme: Record<string, unknown>,
  biomeTheme: Theme
) => {
  // wrap fromTheme to simplify the code below
  const fromTheme = (themeKey: string) =>
    kyruusFromTheme(themeKey)({ theme: kyruusTheme });

  const fontFace = fromTheme('font_face');

  return {
    MuiButton: buildButton(kyruusTheme, biomeTheme),
    MuiIconButton: buildIconButton(kyruusTheme, biomeTheme),
    MuiLink: buildLink(kyruusTheme, biomeTheme),
    MuiTypography: {
      defaultProps: {
        variant: 'body1'
      },
      styleOverrides: {
        root: {
          fontFamily: fontFace
        }
      }
    }
  };
};
